<!-- HEADER -->
<div 
    mat-dialog-title 
    class="title header p-8"
    [ngClass]="[noticia.categoria.cor_template]"
>

    <div class="toolbar mb-8" fxLayout="row" fxLayoutAlign="space-between center">

        <div *ngIf="tipoMidiaEnum.Download == tipoMidia">
            <app-secured-download [src]="getUrlMidia()" [fileName]="noticia.titulo"></app-secured-download>
        </div>

        <div *ngIf="isUserControlAllowed()" fxFlex fxLayout="row" fxLayoutAlign="start center">

            <!-- Editar  -->
            <button *ngIf="!loadingIndicator"  mat-icon-button aria-label="Editar" (click)="openAlterar()">
                <mat-icon>edit</mat-icon>
            </button>

            <!-- Excluir -->
            <button 
                *ngIf="!loadingIndicator" 
                mat-icon-button aria-label="Apagar" 
                (click)="deleteNoticia()"
            >
                <mat-icon>delete</mat-icon>
            </button>
            <mat-spinner *ngIf="loadingIndicator" diameter="20"></mat-spinner>
            <!-- / Excluir -->

        </div>
        <!-- CLOSE DIALOG BUTTON -->
        <button mat-icon-button (click)="onNoClick()" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
        <!-- / CLOSE DIALOG BUTTON -->

    </div>

    <div class="pr-8 m-8" fxLayout="row" fxLayoutAlign="start center">

        <div class="user-image mr-8 mr-sm-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
            <img 
                [src]="noticia.user.url_avatar"
                style="border-radius: 60px;"
                height="96"
                width="96"
            />
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
            [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2">
                {{noticia.titulo}}
            </div>
            <div class="subtitle secondary-text">
                <span>{{categoria.nome}}</span>
            </div>
            <div class="subtitle secondary-text">
                <span>por </span>
                <span>{{noticia.user.name}}</span>
            </div>
            <div class="subtitle secondary-text">
                <span>em </span>
                <span>{{noticia.created_at | date:'dd/MM/yyyy'}}</span>
            </div>
        </div>
    </div>
</div>
<!-- / HEADER -->

<!-- CONTENT -->

<mat-dialog-content class="content-card">
    <div id="noticia-content" class="content m-8 p-16">
        <div class="noticia-texto">
            <div fxLayout="column" class="article">
                <div id="noticia-content-midia" *ngIf="midia" [ngSwitch]="tipoMidia" class="media" fxLayoutAlign="center center">
                    <div *ngSwitchCase="tipoMidiaEnum.Imagem">
                        <app-secured-image [src]="getUrlMidia()" [alt]="noticia.titulo"></app-secured-image>
                    </div>
                
                    <div *ngSwitchCase="tipoMidiaEnum.Video">
                        <app-secured-video [src]="getUrlMidia()" [alt]="noticia.titulo"></app-secured-video>
                    </div>
                </div>


                <div *ngIf="noticia.texto" class="message mb-16" [innerHTML]="noticia.texto"></div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<!-- / CONTENT -->